import React from 'react'

const Developer_Foundations_Course_Exam = () => {
  return (
    <div>
      <h1>Developer Foundations Course Exam</h1>
    </div>
  )
}

export default Developer_Foundations_Course_Exam
